/**
 * The capabilities that carry a tool (Feature 87, D2). A tool ships inside
 * every capability whose environment lists it, so it leaves the index only
 * once none does; each carrier links to its own page, where it is
 * uninstalled. The infra plugin is never uninstalled, so a tool it carries
 * stays.
 */
import { Link } from 'react-router-dom';

import type { Carrier } from '@optum/api-client/types';

import { SectionCard, SectionCardBody } from '../../ui/SectionCard.js';
import { Badge } from '../../ui/finixt.js';

export function ToolCarriersCard({ carriers }: { carriers: Carrier[] }) {
  return (
    <SectionCard
      title="Carried by"
      subtitle={
        carriers.length > 0
          ? 'Installed capabilities whose environment ships this tool. It can be deleted once none does.'
          : 'No installed capability carries this tool, so it can be deleted.'
      }
    >
      {carriers.length > 0 && (
        <SectionCardBody style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
          {carriers.map((carrier) => (
            <div
              key={carrier.name}
              style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-between',
                gap: 11,
                fontSize: 'var(--text-body-md)',
              }}
            >
              <Link
                to={`/plugins/capabilities/${encodeURIComponent(carrier.name)}`}
                className="mono"
                style={{ color: 'var(--text-accent)' }}
              >
                {carrier.name}
              </Link>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 7,
                  color: 'var(--text-muted)',
                }}
              >
                <span className="mono">{carrier.version}</span>
                {carrier.is_infra ? (
                  <Badge tone="violet" shape="square">
                    Infra
                  </Badge>
                ) : null}
              </span>
            </div>
          ))}
        </SectionCardBody>
      )}
    </SectionCard>
  );
}
